import { render, staticRenderFns } from "./message-snackbar.vue?vue&type=template&id=1e081c17"
import script from "./message-snackbar.vue?vue&type=script&lang=js"
export * from "./message-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports